export default __webpack_public_path__ + "static/media/githubactions.47684f71.svg";